import { __assign } from "tslib";
import { schema } from 'normalizr';
import uuidv4 from 'uuid/v4';
export var item = new schema.Entity('items', {}, {
    // assign IDs to items if they don't exist
    processStrategy: function (entity, parent) {
        // have to mutate this as normalizr looks at the original object for an id :(
        Object.assign(entity, {
            id: entity.id || uuidv4(),
            parentId: parent.id && parent.className !== 'Canvas' ? parent.id : null,
        });
        return __assign({}, entity);
    },
    idAttribute: 'id',
});
item.define({
    children: [item],
});
export var itemArray = [item];
export var design = new schema.Object({
    children: itemArray,
});
